<template>
    <div>
        <b-button variant="primary" @click="openModalProvider" v-if="!providerItem">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap text-capitalize">
                {{ $t("match_rules.assign_provider") }}
            </span>
        </b-button>
        
        <b-modal v-model="showModalProvider" :title="$t('match_rules.assign_provider')" @hide="resetForm" hide-footer
            no-close-on-backdrop size="lg">
            <b-form @submit.prevent="saveItem">
                <validation-observer ref="refFormObserver">
                    <validation-provider #default="validationContext" :name="$t('match_rules.provider')"
                        rules="required">
                        <b-form-group :label="$t('match_rules.main_provider')">
                            <v-select multiple :options="providerOptions" v-model="formProvider.value" class="w-100"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :reduce="val => val.value"
                                :placeholder="$t('match_rules.provider')" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider #default="validationContext" :name="$t('match_rules.action')" rules="required">
                        <b-form-group :label="$t('match_rules.action')">
                            <v-select :options="actionProviderOptions" v-model="formProvider.action" class="w-100"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :reduce="val => val.value" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </validation-observer>
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="primary" class="mr-2" @click="closeModalProvider">
                        {{ $t("actions.cancel") }}
                    </b-button>
                    <b-button type="submit" variant="success">
                        {{ $t("actions.save") }}
                    </b-button>
                </div>

            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { ref, watch, computed, onMounted, getCurrentInstance, reactive } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";



export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        editItem: Object,
        providerItem: Object,
    },
    setup(props, { emit }) {

        // form validation component
        const { proxy } = getCurrentInstance();
        const { refFormObserver, getValidationState } = formValidation();

        const showModalProvider = ref(false);

        // formProvider for modal provider
        const formProvider = reactive({
            action: '',
            field: 'provider',
            valueType: 'string',
            value: [],
        });

        // Retrieves the list of actions from Vuex
        const actionProviderOptions = computed(() => {
            return store.getters["alarm_action/getProviderItems"].map(option => ({
                label: proxy.$t(`match_rules_action.${option.description}`),
                value: option.description,
            }));
        })

        // Retrieves the list of providers from Vuex
        const providerOptions = computed(() => {
            return store.getters["alarm_filter_types/getSelectedProviders"].map(option => ({
                label: option.provider,
                value: option.provider
            }));
        });

        // Fetches alarm actions and filter providers when the component is mounted
        onMounted(() => {
            store.dispatch("alarm_action/getAll");
            store.dispatch("alarm_filter_types/getProviders");
        });

        // Watches for changes to the item being edited and opens the provider modal if its a provider rule
        watch(() => props.editItem, (newItem) => {
            // conditional saving
            if (newItem && newItem.field === 'provider') {
                formProvider.action = newItem.action;
                formProvider.field = newItem.field;
                formProvider.valueType = newItem.valueType;
                formProvider.value = [...newItem.value];
                showModalProvider.value = true;
            }
        });

        const openModalProvider = () => {
            resetForm();
            showModalProvider.value = true;
        };

        const closeModalProvider = () => {
            resetForm();
            showModalProvider.value = false;
        };

        const saveItem = async () => {
            const validation = await refFormObserver.value.validate();
            if (!validation) return;

            if (showModalProvider.value) {
                emit("save", { ...formProvider });
                closeModalProvider();
                return;
            }

            closeModalProvider();
        };

        const resetForm = () => {
            formProvider.action = '';
            formProvider.field = 'provider';
            formProvider.valueType = 'string';
            formProvider.value = [];

            //reset fields
            store.commit("alarm_filter_types/resetFields");
        };

        return {
            saveItem,
            resetForm,
            formProvider,
            refFormObserver,
            getValidationState,
            showModalProvider,
            openModalProvider,
            closeModalProvider,
            actionProviderOptions,
            providerOptions
        };
    }

};
</script>